/* jshint undef: true, unused: true */

var gqlWrapper = require('../../../../js_functions/graphql/graphql-wrapper'),
    gqlStringifier = require('../../../../js_functions/graphql/graphql-js-stringifier'),
    answersGQL = require('raw-loader!./equipment-list-answers.graphql'),
    listGQL = require('raw-loader!./equipment-list.graphql'),
    saveMutationGQL = require('raw-loader!./equipment-submission-mutation.graphql'),
    deleteGQL = require('raw-loader!./equipment-delete.graphql');

var // Variables
    ajaxCall = gqlWrapper().ajaxCall,
    //Functions
    queryAnswers,
    queryList,
    mutateAnswers,
    submitEquipment,
    deleteAnswer;
const APIVersion = 1;

queryAnswers = function (recordUuid) {
  return ajaxCall(answersGQL.replace('$record', recordUuid));
};

queryList = function (searchTerm, searchField) {
  return ajaxCall(listGQL
    .replace('$query', searchTerm)
    .replace('$field', searchField)
  );
};

mutateAnswers = function (answers, answerUuid, recordUuid, equipmentId) {
  return ajaxCall(
    saveMutationGQL.replace(
      '$mutation',
      gqlStringifier({
        id: answerUuid,
        recordId: recordUuid,
        recordType: 'incident',
        equipmentId: equipmentId,
        answers: answers
      })
    )
  );
};

submitEquipment = function (formUid, answers, answerUuid, recordUuid, values, successCallback, errorCallback) {
  return new Promise((resolve, reject) => {
    mutateAnswers(answers, answerUuid, recordUuid, values.equipmentId)
      .then(function(data) {
        var params = {
          formUid             : formUid,
          brandName           : values.brandName,
          dataViewRecordIndex : values.dataViewRecordIndex
        };
        const callback = () => successCallback(data, params);
        resolve(callback);
      },
      function(error){
        errorCallback(error);
        reject();
      });
  });
};

deleteAnswer = function (answerId) {
  return ajaxCall(deleteGQL
    .replace('$answersId', answerId));
};

module.exports = {
  APIVersion                : APIVersion,
  getEquipmentSearchResults : queryList,
  submitEquipment           : submitEquipment,
  queryAnswers              : queryAnswers,
  deleteAnswer              : deleteAnswer
};
